import { render, staticRenderFns } from "./PersonDetailDialog.vue?vue&type=template&id=662cc014&"
import script from "./PersonDetailDialog.vue?vue&type=script&lang=js&"
export * from "./PersonDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports